(() => {
  const config = document.getElementById('IshvaryaRefinementConfig');
  if (!config) return;
  const labels = JSON.parse(config.textContent).carousel;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const heroInit = () => document.querySelectorAll('[data-ish-hero]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const controls = root.querySelector('[data-hero-controls]');
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const pause = root.querySelector('[data-hero-pause]');
    let index = 0, paused = false, focused = false, visible = true, timer;
    const schedule = () => {
      clearTimeout(timer);
      root.dataset.state = paused || motion.matches ? 'paused' : focused ? 'focused' : document.hidden || !visible ? 'offscreen' : 'playing';
      if (root.dataset.autoplay === 'true' && !paused && !motion.matches && !focused && visible && !document.hidden && slides.length > 1) {
        timer = setTimeout(() => show(index + 1), Number(root.dataset.interval) || 5000);
      }
    };
    const show = target => {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      root.dataset.activeSlide = String(index + 1);
      root.dispatchEvent(new CustomEvent('ishvarya:hero-change'));
      const nextImage = slides[(index + 1) % slides.length]?.querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      schedule();
    };
    controls.hidden = slides.length < 2;
    root.querySelector('[data-hero-prev]').addEventListener('click', () => show(index - 1));
    root.querySelector('[data-hero-next]').addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    pause?.addEventListener('click', () => {
      paused = !paused;
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? labels.play : labels.pause);
      schedule();
    });
    root.addEventListener('focusin', event => { focused = event.target.matches(':focus-visible'); schedule(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }).observe(root);
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', schedule);
    root.addEventListener('shopify:block:select', event => {
      const selected = slides.findIndex(slide => slide.contains(event.target));
      if (selected >= 0) { paused = true; show(selected); }
    });
    show(0);
  });
  const chatDisplay = new WeakMap(), chatBottom = new WeakMap(), chatObservers = new WeakSet();
  const syncCartChat = () => {
    const hide = !!document.querySelector('.ishvarya-cart-drawer.is-open');
    const bar = document.querySelector('.ic-mobile-bar');
    const lift = bar?.getBoundingClientRect().width ? Math.ceil(innerHeight - bar.getBoundingClientRect().top + 16) : null;
    if(bar && !chatObservers.has(bar)){chatObservers.add(bar);new ResizeObserver(syncCartChat).observe(bar);}

    document.querySelectorAll('#moosedesk-widget-host,inbox-online-store-chat').forEach(host => {
      if(host.shadowRoot && !chatObservers.has(host.shadowRoot)){
        chatObservers.add(host.shadowRoot);
        new MutationObserver(syncCartChat).observe(host.shadowRoot,{childList:true,subtree:true});
      }
      const launcher = host.shadowRoot?.querySelector('.mdw-float-btn');
      if(launcher){
        if(!chatObservers.has(launcher)){chatObservers.add(launcher);new MutationObserver(syncCartChat).observe(launcher,{attributes:true,attributeFilter:['style']});}
        if(lift !== null){
          if(!chatBottom.has(launcher))chatBottom.set(launcher,[launcher.style.getPropertyValue('bottom'),launcher.style.getPropertyPriority('bottom')]);
          const offset = Math.ceil(lift / (parseFloat(getComputedStyle(launcher).zoom) || 1))+'px';
          if(launcher.style.getPropertyValue('bottom') !== offset || launcher.style.getPropertyPriority('bottom') !== 'important')launcher.style.setProperty('bottom',offset,'important');
        }else if(chatBottom.has(launcher)){
          const [value,priority] = chatBottom.get(launcher);chatBottom.delete(launcher);
          if(value)launcher.style.setProperty('bottom',value,priority);else launcher.style.removeProperty('bottom');
        }
      }

      if(!chatObservers.has(host)){
        chatObservers.add(host);
        new MutationObserver(syncCartChat).observe(host,{attributes:true,attributeFilter:['style']});
      }
      if(hide){
        if(!chatDisplay.has(host))chatDisplay.set(host,[host.style.getPropertyValue('display'),host.style.getPropertyPriority('display')]);
        if(host.style.getPropertyValue('display') !== 'none' || host.style.getPropertyPriority('display') !== 'important')host.style.setProperty('display','none','important');
      }else if(chatDisplay.has(host)){
        const [value,priority] = chatDisplay.get(host);chatDisplay.delete(host);
        if(value)host.style.setProperty('display',value,priority);else host.style.removeProperty('display');
      }
    });
  };
  window.addEventListener('resize',syncCartChat);
  const dialogInit = () => document.querySelectorAll('[data-ishvarya-cart-drawer],[data-ishvarya-header-cart-drawer]').forEach(drawer => {
    if (drawer.dataset.portalReady) return;
    drawer.dataset.portalReady = 'true';
    const owner = drawer.closest('[id^="shopify-section-"]')?.id;
    document.body.append(drawer);
    const panel = drawer.querySelector('[role="dialog"]');
    panel.tabIndex = -1;
    let open = false, returnFocus, background = [];
    drawer.inert = true;
    const targets = () => [...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
    const sync = () => {
      const next = drawer.classList.contains('is-open');
      if (next === open) return;
      open = next;
      syncCartChat();
      drawer.inert = !open;
      drawer.setAttribute('aria-hidden', String(!open));
      if (open) {
        returnFocus = document.activeElement;
        background = [...document.body.children].filter(el => el !== drawer && !['SCRIPT','STYLE','LINK'].includes(el.tagName)).map(el => [el, el.inert]);
        background.forEach(([el]) => { el.inert = true; });
        (drawer.querySelector('[data-ishvarya-cart-close],[data-header-cart-close]') || panel).focus();
      } else {
        background.forEach(([el, state]) => { el.inert = state; });
        background = [];
        if (returnFocus?.isConnected && !returnFocus.disabled) returnFocus.focus();
      }
    };
    const observer = new MutationObserver(sync);
    observer.observe(drawer, {attributes:true, attributeFilter:['class']});
    drawer.addEventListener('keydown', event => {
      if (!open) return;
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopImmediatePropagation();
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('ishvarya-cart-drawer-open');
        document.body.classList.remove('ishvarya-cart-drawer-open');
        sync();
      } else if (event.key === 'Tab') {
        const focusable = targets(), first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); panel.focus(); }
        else if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    }, true);
    document.addEventListener('shopify:section:unload', event => {
      if (owner && event.target.id === owner) { drawer.classList.remove('is-open'); sync(); observer.disconnect(); drawer.remove(); }
    });
    sync();
  });
  const mobileOffersInit = () => document.querySelectorAll('[data-combo-builder]').forEach(builder => {
    if (builder.dataset.mobileOffersReady) return;
    const offers = builder.querySelector('.ish-combo-tiers');
    const layout = builder.querySelector('.ic-layout');
    const summary = builder.querySelector('.ic-summary');
    if (!offers || !layout || !summary) return;
    builder.dataset.mobileOffersReady = 'true';
    const anchor = document.createComment('offer position');
    offers.before(anchor);
    const narrow = matchMedia('(max-width: 749px)');
    const place = () => {
      if (narrow.matches) layout.prepend(offers);
      else anchor.after(offers);
    };
    narrow.addEventListener('change', place);
    place();
  });
  let reviewReturnFocus = null;
  const reviewLinksInit = () => document.querySelectorAll('.jdgm-cards-carousel,.jdgm-testimonials-carousel').forEach(widget => {
    if (widget.dataset.ishReviewLinksReady) return;
    widget.dataset.ishReviewLinksReady = 'true';
    const addLinks = () => widget.querySelectorAll('.jdgm-card').forEach(card => {
      if (card.querySelector('.ish-review-full')) return;
      const text = card.querySelector('.jdgm-text');
      if (!text?.textContent.trim()) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ish-review-full';
      button.textContent = JSON.parse(config.textContent).reviews.read_full;
      card.append(button);
    });
    widget.addEventListener('click', event => {
      const button = event.target.closest('.ish-review-full');
      if (!button) return;
      event.stopPropagation();
      reviewReturnFocus = button;
      button.closest('.jdgm-card')?.click();
    }, true);
    new MutationObserver(addLinks).observe(widget, {childList:true,subtree:true});
    addLinks();
  });
  const init = () => { heroInit(); dialogInit(); mobileOffersInit(); reviewLinksInit(); };
  let reviewFrame;
  new MutationObserver(() => {
    cancelAnimationFrame(reviewFrame);
    reviewFrame = requestAnimationFrame(() => {
      reviewLinksInit();
      syncCartChat();
      if (reviewReturnFocus && ![...document.querySelectorAll('.jdgm-modal')].some(modal => modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden')) {
        const target = reviewReturnFocus;
        reviewReturnFocus = null;
        if (target.isConnected) target.focus({preventScroll:true});
      }
    });
  }).observe(document.body, {childList:true,subtree:true});
  init();
  document.addEventListener('shopify:section:load', init);
})();

